export default "__VITE_ASSET__Cx3sM2Mz__"